import React from 'react'
import PropTypes from 'prop-types'
import Box from '@mui/material/Box'
import FormControl from '@mui/material/FormControl'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import Select from '@mui/material/Select'
import TuneSharpIcon from '@mui/icons-material/TuneSharp'
import Checkbox from '@mui/material/Checkbox'
import ListItemText from '@mui/material/ListItemText'
import OutlinedInput from '@mui/material/OutlinedInput'

const Config = ({
  config,
  configItems,
  onConfigChange,
}) => {
  if (Object.keys(configItems).length === 0) return null
  if (Object.values(configItems).every(item => !item.show)) return null
  return (
    <Box>
      <Box display='flex' flexDirection='row' alignItems='center' columnGap={1} rowGap={1} flexWrap='wrap'>
        <TuneSharpIcon
          sx={{
            fontSize: 16,
            marginRight: '-4px',
          }}
        />
        {Object.keys(configItems).map(key => {
          const configItem = configItems[key]
          if (!configItem.show) return null
          const isMulti = !!configItem.multi
          const value = key in config ? config[key] : (isMulti ? [] : '')
          return (
            <Box key={key}>
              <Box>
                <FormControl size='small' variant='outlined' sx={{ minWidth: 120, height: 29 }}>
                  <InputLabel id={`${key}-label`}>{configItem.name}</InputLabel>
                  <Select
                    id={`${key}-select`}
                    labelId={`${key}-label`}
                    label={configItem.name}
                    value={value}
                    multiple={isMulti}
                    onChange={event => onConfigChange(key, isMulti ? event.target.value : event.target.value)}
                    renderValue={selected => {
                      if (isMulti) {
                        return configItem.items
                          .filter(opt => selected.includes(opt.value))
                          .map(opt => opt.name)
                          .join(', ')
                      }
                      return configItem.items.find(t => t.value.toString() === selected.toString())?.name
                    }}
                    sx={{ height: 29 }}
                    input={isMulti ? <OutlinedInput label={configItem.name} /> : undefined}
                    inputProps={{
                      sx: {
                        paddingTop: '4px',
                        paddingBottom: '4px',
                        fontSize: 15,
                      }
                    }}
                    MenuProps={{
                      anchorOrigin: {
                        vertical: 'bottom',
                        horizontal: 'left',
                      },
                      transformOrigin: {
                        vertical: 'top',
                        horizontal: 'left',
                      },
                    }}
                  >
                    {configItem.items.map(subItem => (
                      <MenuItem
                        key={subItem.value}
                        value={subItem.value}
                        color='secondary'
                      >
                        {isMulti && (
                          <Checkbox checked={Array.isArray(value) && value.includes(subItem.value)} />
                        )}
                        <ListItemText primary={subItem.name} />
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>
            </Box>
          )
        })}
      </Box>
    </Box>
  )
}

Config.propTypes = {
  config: PropTypes.object.isRequired,
  configItems: PropTypes.object.isRequired,
  onConfigChange: PropTypes.func.isRequired,
}

export default Config